<template lang="pug">
tabs-container-vue(
    :tabs="tabs"
    ref="tabs-container"
    v-if="cardVisible"
    data-cy="tabs_container"
  )
    template(v-slot:resumen)
      resumen-ia-vue(
        :cardData="cardData.values"
      )
</template>

<script>
import mixins from 'common/mixins'
import { marked } from 'marked'

export default {
  name: 'document-card-vue',
  props: {
    metadataFields: { type: Array, default: () => [] }
  },
  mixins: [mixins.translate],
  components: {
    'tabs-container-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/layout/TabsContainer'
    ),
    'resumen-ia-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/documents/ResumenIa'
    ),
  },
  computed: {
    cardData() {
      var documentCard = this.metadataFields.find(field => field.id == 'document_card')

      return ((documentCard || {}).values || []).find(field => field.id == 'resumen')
    },
    cardVisible() {
      return this.cardData && this.cardData.values.length > 0
    },
    label() {
      return this.cardVisible ? this.cardData.label : ''
    },
    tabs() {
      return [{ key: 'resumen', label: this.label }]
    }
  },
  methods: {
    processContent(text) {
      if (typeof text != 'string')
        return ''

      return marked.parse(text)
    }
  }
}
</script>
